class ImportVersionError extends Error {
  constructor(message) {
    super(message); // (1)
    this.name = "ImportVersionError"; // (2)
  }
}

export default ImportVersionError;
